export * from './dialog.module';
export { DialogTemplateConfig } from './models/dialog-template.config';
export { DialogConfig } from './models/dialog.config';
export { DialogService } from './services/dialog.service';
